import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { SftpImportConfigurationWorkflow, getImportTypeEnumToText, mapToImportTypeEnum, PostImportActionEnum, getPostImportActionDescriptions } from '../../../store/Models/Api/SftpImportModels';

interface ImportTypeInfoSectionLocalProps {
    configData: SftpImportConfigurationWorkflow;
}

type ImportTypeInfoSectionProps = ImportTypeInfoSectionLocalProps & ToxnotComponentProperties;

class ImportTypeInfoSectionComponent extends ToxnotComponent<ImportTypeInfoSectionProps> {
    public render() {
        const { configData, appServices } = this.props;
        const importTypeDescriptions = getImportTypeEnumToText(appServices);
        const postImportActionDescriptions = getPostImportActionDescriptions(appServices);

        return (
            <>
                <p><strong>{this.localizeString("Import Type")}:</strong> {importTypeDescriptions[mapToImportTypeEnum(configData.importType, configData.inventoryMode, configData.dataType)].toString()}</p>
                <p><strong>{this.localizeString("Current Status:")}</strong> <span className={configData.isActive ? "text-success" : "text-warning"}>{configData.isActive ? "Active" : "Inactive"}</span></p>
                <p><strong>{this.localizeString("Post Import Action:")}</strong> {postImportActionDescriptions[configData.postImportAction as PostImportActionEnum] || configData.postImportAction}</p>
                
            </>
        );
    }
}

export const ImportTypeInfoSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(ImportTypeInfoSectionComponent);
